module.exports = __webpack_public_path__ + "static/media/test2_2.796cda04.png";